"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignatures = void 0;
const tslib_1 = require("tslib");
const contractAddress_1 = require("./contractAddress");
const ImpactProvider_1 = require("./ImpactProvider");
const config_1 = require("./config");
const react_1 = tslib_1.__importDefault(require("react"));
const useSignatures = () => {
    const { signer, networkId } = react_1.default.useContext(ImpactProvider_1.ImpactProviderContext);
    /**
     * Signs a given message.
     * ***DO NOT HASH IT***
     * @param {string} message plaintext readable string
     * @returns {Promise<string>} signature
     * @deprecated use `signTypedData` instead
     */
    const signMessage = (message) => {
        // const connectionProvider = signer.web3.currentProvider as unknown as {
        //     existingProvider: { isDesktop: boolean; _metamask?: unknown };
        // };
        // // it is not yet clear why, but metamask is not working with hexlify/toUtf8Bytes
        // if (connectionProvider.existingProvider.isDesktop || connectionProvider.existingProvider._metamask) {
        //     return signer.signMessage(hashMessage(message));
        // }
        if (!signer) {
            throw new Error('no valid signer connected');
        }
        return signer.signMessage({ message });
    };
    /**
     * Sign a message using EIP-712
     * @param {string} message Message to sign
     * @param {SignatureOptions} options Signature options
     * @returns {Promise<TypedSignatureResponse>} Sigature hash
     */
    const signTypedData = async (message, options) => {
        if (!signer) {
            throw new Error('no valid signer connected');
        }
        const expiry = (options === null || options === void 0 ? void 0 : options.expiry) || Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 30;
        const name = (options === null || options === void 0 ? void 0 : options.name) || 'impactMarket';
        const verifyingContract = ((options === null || options === void 0 ? void 0 : options.verifyingContract) ||
            contractAddress_1.ContractAddresses.get(networkId || config_1.networksId.CeloMainnet).PACTDelegator);
        const version = (options === null || options === void 0 ? void 0 : options.version) || '1';
        const domain = {
            chainId: networkId,
            name,
            verifyingContract,
            version
        };
        const types = {
            Auth: [
                { name: 'message', type: 'string' },
                { name: 'expiry', type: 'uint256' }
            ]
        };
        const value = {
            expiry,
            message
        };
        const signature = await signer.signTypedData({ domain, message: value, primaryType: 'Auth', types });
        return { message: value, signature };
    };
    return { signMessage, signTypedData };
};
exports.useSignatures = useSignatures;
//# sourceMappingURL=useSignatures.js.map